import * as yup from 'yup';

export const CONTACT_SCHEMA = yup.object().shape({
    first_name: yup.string().optional(),
    middle_name: yup.string().optional(),
    last_name: yup.string().optional(),
    email: yup.string().email('Email must be a valid email.').optional(),
    phone: yup.string().optional(),
    details: yup.object().shape({
        political_affiliation: yup.string().optional(),
        reputation: yup.number().optional()
    }),
    social_links: yup
        .array()
        .of(
            yup.object().shape({
                type: yup.string().required(),
                url: yup.string().required()
            })
        )
        .required(),
    companies: yup
        .array()
        .of(
            yup.object().shape({
                company: yup.string().optional(),
                work_email: yup.string().optional(),
                work_phone: yup.string().optional(),
                job_title: yup.string().optional()
            })
        )
        .optional(),
    notes: yup
        .array()
        .of(
            yup.object().shape({
                note: yup.string().optional()
            })
        )
        .optional(),
    needs: yup
        .array()
        .of(
            yup.object().shape({
                id: yup.string().optional()
            }),
            yup.object().shape({
                name: yup.string().optional()
            }),
            yup.object().shape({
                need_id: yup.string().required()
            })
        )
        .optional(),
    skills: yup
        .array()
        .of(
            yup.object().shape({
                id: yup.string().optional()
            }),
            yup.object().shape({
                name: yup.string().optional()
            }),
            yup.object().shape({
                skill_id: yup.string().required()
            })
        )
        .optional()
});

export const CONTACT_IMPORT_SCHEMA = yup.object().shape({
    file: yup
        .array()
        .test('file', 'Please select contacts vcf file!', (value) => {
            return !(value?.length === 0);
        })
        .test('file', 'errors.file.file', (value) => {
            if (value.length === 0) {
                return true;
            }
            let check = true;
            value.forEach((singleFile) => {
                if (!(singleFile instanceof File)) {
                    check = false;
                }
            });
            return check;
        })
});
